import React, { useState, Component } from 'react';
import { MessageSquareIcon, XIcon, SendIcon } from 'lucide-react';
const FeedbackSection = () => {
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const handleOpenFeedbackForm = () => {
    setShowFeedbackForm(true);
  };
  const handleCloseFeedbackForm = () => {
    setShowFeedbackForm(false);
    setFeedbackText('');
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Create mailto link with the feedback in the body
    const mailtoLink = `mailto:info@joinemigo.com?subject=Feedback for Emigo&body=${encodeURIComponent(feedbackText)}`;
    // Open email client with the feedback
    window.location.href = mailtoLink;
    // Close the form after submission
    handleCloseFeedbackForm();
  };
  return <section className="py-16 md:py-24 bg-gradient-to-b from-white to-[#FFF5EB]" data-id="element-139">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-140">
        <h2 className="text-3xl md:text-4xl font-bold text-[#E87B5C] mb-4" data-id="element-141">
          Help Us Improve Emigo
        </h2>
        <p className="mt-4 text-xl text-[#E87B5C]/80 mb-8" data-id="element-142">
          Please tell us how Emigo can better assist you! Your feedback helps us
          create a better emotional intelligence companion for everyone.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-143">
          <button className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-br from-[#E87B5C] to-[#D16A4A] text-white font-medium hover:opacity-90 transition-all shadow-sm hover:shadow-md" onClick={handleOpenFeedbackForm} data-id="element-144">
            <MessageSquareIcon className="w-5 h-5 mr-2" data-id="element-145" />
            Give Feedback
          </button>
        </div>
      </div>
      {/* Feedback Form Popup */}
      {showFeedbackForm && <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-146">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 animate-popup" data-id="element-147">
            <div className="flex justify-between items-center mb-6" data-id="element-148">
              <h2 className="text-xl font-bold text-gray-800" data-id="element-149">
                Share Your Feedback
              </h2>
              <button onClick={handleCloseFeedbackForm} className="text-gray-500 hover:text-gray-700 transition-colors" data-id="element-150">
                <XIcon className="w-5 h-5" data-id="element-151" />
              </button>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-152">
              <div data-id="element-153">
                <label htmlFor="feedback" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-154">
                  Your Feedback
                </label>
                <textarea id="feedback" value={feedbackText} onChange={e => setFeedbackText(e.target.value)} rows={6} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#E87B5C] focus:border-[#E87B5C] text-gray-800" placeholder="How can we improve Emigo to better serve your needs?" required data-id="element-155"></textarea>
              </div>
              <div className="flex justify-end space-x-3 pt-2" data-id="element-156">
                <button type="button" onClick={handleCloseFeedbackForm} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-157">
                  Cancel
                </button>
                <button type="submit" className="px-4 py-2 bg-gradient-to-r from-[#E87B5C] to-[#FFD700] text-white rounded-md hover:opacity-90 transition-colors flex items-center" data-id="element-158">
                  Submit to info@joinemigo.com
                  <SendIcon className="ml-2 h-4 w-4" data-id="element-159" />
                </button>
              </div>
            </form>
          </div>
        </div>}
    </section>;
};
export default FeedbackSection;